
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/backToTop",
      function () {
        return require("private-next-pages/backToTop.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/backToTop"])
      });
    }
  